import groq from 'groq';

import { RICH_TEXT } from '../common';

/** Projection for `consumerTrial -> { … }` on Before & After results. */
export const CONSUMER_TRIAL = groq`
  _id,
  results[] {
    title,
    description[] {
      ${RICH_TEXT}
    },
  }
`;
